export const MicroNavbar = {
  fontSize: 'Y1',
  background: 'none',
  backdropFilter: 'none',
};